// import { useMemo } from 'react'

import { theme } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { useIntl } from 'react-intl'

// import { useIsMobile } from 'hooks/useIsMobile'
// import { useRouterExtend } from 'hooks/useRouterExtend'
// import { PREGNANCY_CATEGORY } from 'interfaces/constants/pregenancyCategory'

import { StyledSlider, StyledTrimeterSlider } from './index.styled'

/**
 * First Trimester (0 to 13 Weeks)
 * Second Trimester (14 to 26 Weeks)
 * Third Trimester (27 to 40 Weeks)
 */
type TrimeterSliderProps = {
  currentWeek: number
  isSponsored?: boolean
}
export const TrimeterSlider = ({
  currentWeek,
  isSponsored,
}: TrimeterSliderProps) => {
  const { formatMessage: f } = useIntl()
  // const { locale } = useRouterExtend()
  // const remainingWeeks = 40 - currentWeek
  // const currentTrimeter = useMemo(() => {
  //   if (currentWeek < 14) {
  //     return 0
  //   } else if (currentWeek >= 27) {
  //     return 2
  //   }
  //   return 1
  // }, [currentWeek])

  // const categoryLink = PREGNANCY_CATEGORY[locale][currentTrimeter]
  // const renderContent = () => {
  //   if (remainingWeeks === 1)
  //     return f({
  //       id: 'dueDateTool.weekToGo.one',
  //       defaultMessage: '1 week to go',
  //     })
  //   if (remainingWeeks <= 0)
  //     return f({
  //       id: 'dueDateTool.weekToGo.outOfRange',
  //       defaultMessage: 'Anytime now',
  //     })

  //   return f(
  //     {
  //       id: 'dueDateTool.weekToGo',
  //       defaultMessage: '{week} weeks to go',
  //     },
  //     {
  //       week: remainingWeeks,
  //     },
  //   )
  // }

  return (
    <StyledTrimeterSlider isSponsored={isSponsored}>
      <StyledSlider
        min={0}
        max={40}
        value={currentWeek}
        // thumbSize={isMobile ? 20 : 24}
        thumbSize={1}
        size="lg"
        radius="xl"
        showLabelOnHover={false}
        marks={[{ value: 13 }, { value: 26 }]}
        onChange={() => null}
        isStatic
        labelAlwaysOn
        label={(value) => (
          <Text size="p5" as="span" color={theme.colors.pink800}>
            {f(
              {
                id: 'dueDateTool.weekNumber',
                defaultMessage: 'Week {weekNumber}',
              },
              { weekNumber: value },
            )}
          </Text>
        )}
      />
      {/* <a
        href={categoryLink}
        className="pointer-event-child-none"
        data-event-category="Health Tool"
        data-event-action="Due Date Slider Click"
        data-event-label={`${getHelloSitesUrl(locale)}${categoryLink}`}
      >
        <Button color="transparent" size="md">
          <Text
            size="c1"
            type="bold"
            color={theme.colors.gray600}
            className="btn-text"
          >
            {renderContent()}
          </Text>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M13.071 12.0002L9.24995 8.17915C8.83595 7.76515 8.83595 7.09315 9.24995 6.67915C9.66395 6.26515 10.336 6.26515 10.75 6.67915L15.364 11.2932C15.755 11.6842 15.755 12.3172 15.364 12.7072L10.75 17.3212C10.336 17.7352 9.66395 17.7352 9.24995 17.3212C8.83595 16.9072 8.83595 16.2352 9.24995 15.8212L13.071 12.0002Z"
              fill="#595959"
            />
          </svg>
        </Button>
      </a> */}
    </StyledTrimeterSlider>
  )
}
